const FILENAME_PATTERN =
  /^_?(DSC|IMG|DSCN|_MG|MVI|VID|MOV|P\d{3,})[\w-]*$|^.+\.(jpe?g|png|gif|tiff?|raw|cr2|nef|bmp|webp|heic)$/i

export const getArtworkTitle = (title) => {
  if (typeof title !== "string") return "Untitled"
  const trimmed = title.trim()
  if (!trimmed || FILENAME_PATTERN.test(trimmed)) return "Untitled"
  return trimmed
}
